// extracted by mini-css-extract-plugin
export default {"link":"vO-z","disabled":"wO-z"};